// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/img/chatbtnicon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-chatBtn .btn-chat-live {
  position: relative;
  /* padding: 13px 25px; */
  padding: 7px 15px;
  /* background-color: #ffb500; */
  background-color: #433f3f;
  text-decoration: none;
  color: #333;
  border-radius: 15px;
  /* border: 1px solid white; */
  /* box-shadow: 0px 2px 0px #02679e; */
  transition: all 0.2s;
  z-index: 1;
  outline: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
.toolbar-chatBtn .btn-chat-live:hover {
  /* transform: translateY(-5px); */
  /* padding: calc(13px * 1.2) calc(25px * 1.2); */
  /* padding-right: calc(22px * \$btn-chat-livePaddingScalePlus); */
  /* background-color: yellow; */
  /* border: none; */
  /* box-shadow: 0px 5px 10px #0271ae; */
}
.toolbar-chatBtn .btn-chat-live:hover > span:before {
  animation: none;
}
.toolbar-chatBtn .btn-chat-live:active {
  transform: translateY(0px);
  padding: calc(13px * 0.95) calc(25px * 0.95);
  /* box-shadow: inset 0px 2px 1px #02679e; */
}

.toolbar-chatBtn .btn-chat-live_transparent {
  border: 0px;
  border-radius: 0px;
  padding: 13px 25px;
  background-color: rgba(255, 255, 255, 0);
  color: #fff;
  box-shadow: none;
}
.toolbar-chatBtn .btn-chat-live_transparent:hover {
  box-shadow: none;
  background-color: inherit;
}

.toolbar-chatBtn .btn-chat-live_live {
  padding-right: 22px;
}

span.live-icon-container::before {
  content: '';
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  width: 150%;
  height: 150%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  /* background-image: url('path/to/image.jpg'); */
  background-size: cover; /* or 'contain' to fit within the element */
  /* other styling properties */
}

span.live-icon {
  display: inline-block;
  position: relative;
  top: calc(50% - 5px);
  /* background-color: rgba(14, 76, 209, 1); */
  /* background-color: red; */
  background-color: #fff;
  width: 10px;
  height: 10px;
  margin-left: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  z-index: 1;
}
span.live-icon:before {
  content: '';
  display: block;
  position: absolute;
  /* background-color: rgba(14, 76, 209, 1); */
  /* background-color: rgba(255, 0, 0, 0.6); */
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: live 2s ease-in-out infinite;
  z-index: -1;
}

@keyframes live {
  0% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(3.5, 3.5);
    background-color: rgba(255, 0, 0, 0);
  }
}
small {
  position: absolute;
  font-size: 0.9em;
  color: rgba(255, 255, 255, 0.5);
  bottom: 2rem;
}
small b {
  font-weight: bold;
  color: rgba(255, 255, 255, 0.8);
  z-index: -1;
}

@media only screen and (max-width: 500px) {
  .toolbar-chatBtn {
    flex-direction: column;
    padding-left: 50px;
    padding-right: 50px;
  }

  .btn-chat-live {
    width: 250px;
  }

  span.live-icon {
    position: absolute;
    right: 20rem;
  }
}
@media only screen and (max-width: 350px) {
  .btn-chat-live {
    width: 100%;
  }
}

@keyframes float {
  0% {
    transform: translatey(0px);
  }
  50% {
    transform: translatey(-15px);
  }
  100% {
    transform: translatey(0px);
  }
}

span.live-icon-container {
  animation: float 3s ease-in-out infinite;
}

.scroll-feed {
  height: auto !important;
}

.icon-img {
  height: 32px !important;
}

.d-flex {
  display: flex !important;
}

.h-v-center {
}
`, "",{"version":3,"sources":["webpack://./src/modules/private/components/design-lab/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,qCAAqC;EACrC,oBAAoB;EACpB,UAAU;EACV,aAAa;EACb,mDAAmD;AACrD;AACA;EACE,iCAAiC;EACjC,gDAAgD;EAChD,gEAAgE;EAChE,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EAEE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oEAA0E;EAC1E,gDAAgD;EAChD,sBAAsB,EAAE,2CAA2C;EACnE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,4CAA4C;EAC5C,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,4CAA4C;EAC5C,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAElB,uCAAuC;EACvC,WAAW;AACb;;AAYA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,oCAAoC;EACtC;AACF;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;AACA","sourcesContent":[".toolbar-chatBtn .btn-chat-live {\r\n  position: relative;\r\n  /* padding: 13px 25px; */\r\n  padding: 7px 15px;\r\n  /* background-color: #ffb500; */\r\n  background-color: #433f3f;\r\n  text-decoration: none;\r\n  color: #333;\r\n  border-radius: 15px;\r\n  /* border: 1px solid white; */\r\n  /* box-shadow: 0px 2px 0px #02679e; */\r\n  transition: all 0.2s;\r\n  z-index: 1;\r\n  outline: none;\r\n  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\r\n}\r\n.toolbar-chatBtn .btn-chat-live:hover {\r\n  /* transform: translateY(-5px); */\r\n  /* padding: calc(13px * 1.2) calc(25px * 1.2); */\r\n  /* padding-right: calc(22px * $btn-chat-livePaddingScalePlus); */\r\n  /* background-color: yellow; */\r\n  /* border: none; */\r\n  /* box-shadow: 0px 5px 10px #0271ae; */\r\n}\r\n.toolbar-chatBtn .btn-chat-live:hover > span:before {\r\n  -webkit-animation: none;\r\n  animation: none;\r\n}\r\n.toolbar-chatBtn .btn-chat-live:active {\r\n  transform: translateY(0px);\r\n  padding: calc(13px * 0.95) calc(25px * 0.95);\r\n  /* box-shadow: inset 0px 2px 1px #02679e; */\r\n}\r\n\r\n.toolbar-chatBtn .btn-chat-live_transparent {\r\n  border: 0px;\r\n  border-radius: 0px;\r\n  padding: 13px 25px;\r\n  background-color: rgba(255, 255, 255, 0);\r\n  color: #fff;\r\n  box-shadow: none;\r\n}\r\n.toolbar-chatBtn .btn-chat-live_transparent:hover {\r\n  box-shadow: none;\r\n  background-color: inherit;\r\n}\r\n\r\n.toolbar-chatBtn .btn-chat-live_live {\r\n  padding-right: 22px;\r\n}\r\n\r\nspan.live-icon-container::before {\r\n  content: '';\r\n  display: block;\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0;\r\n  width: 150%;\r\n  height: 150%;\r\n  background-image: url('../../../../assets/img/chatbtnicon.png') !important;\r\n  /* background-image: url('path/to/image.jpg'); */\r\n  background-size: cover; /* or 'contain' to fit within the element */\r\n  /* other styling properties */\r\n}\r\n\r\nspan.live-icon {\r\n  display: inline-block;\r\n  position: relative;\r\n  top: calc(50% - 5px);\r\n  /* background-color: rgba(14, 76, 209, 1); */\r\n  /* background-color: red; */\r\n  background-color: #fff;\r\n  width: 10px;\r\n  height: 10px;\r\n  margin-left: 20px;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  border-radius: 50%;\r\n  z-index: 1;\r\n}\r\nspan.live-icon:before {\r\n  content: '';\r\n  display: block;\r\n  position: absolute;\r\n  /* background-color: rgba(14, 76, 209, 1); */\r\n  /* background-color: rgba(255, 0, 0, 0.6); */\r\n  background-color: #fff;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 50%;\r\n  -webkit-animation: live 2s ease-in-out infinite;\r\n  animation: live 2s ease-in-out infinite;\r\n  z-index: -1;\r\n}\r\n\r\n@-webkit-keyframes live {\r\n  0% {\r\n    transform: scale(1, 1);\r\n  }\r\n  100% {\r\n    transform: scale(3.5, 3.5);\r\n    background-color: rgba(255, 0, 0, 0);\r\n  }\r\n}\r\n\r\n@keyframes live {\r\n  0% {\r\n    transform: scale(1, 1);\r\n  }\r\n  100% {\r\n    transform: scale(3.5, 3.5);\r\n    background-color: rgba(255, 0, 0, 0);\r\n  }\r\n}\r\nsmall {\r\n  position: absolute;\r\n  font-size: 0.9em;\r\n  color: rgba(255, 255, 255, 0.5);\r\n  bottom: 2rem;\r\n}\r\nsmall b {\r\n  font-weight: bold;\r\n  color: rgba(255, 255, 255, 0.8);\r\n  z-index: -1;\r\n}\r\n\r\n@media only screen and (max-width: 500px) {\r\n  .toolbar-chatBtn {\r\n    flex-direction: column;\r\n    padding-left: 50px;\r\n    padding-right: 50px;\r\n  }\r\n\r\n  .btn-chat-live {\r\n    width: 250px;\r\n  }\r\n\r\n  span.live-icon {\r\n    position: absolute;\r\n    right: 20rem;\r\n  }\r\n}\r\n@media only screen and (max-width: 350px) {\r\n  .btn-chat-live {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@keyframes float {\r\n  0% {\r\n    transform: translatey(0px);\r\n  }\r\n  50% {\r\n    transform: translatey(-15px);\r\n  }\r\n  100% {\r\n    transform: translatey(0px);\r\n  }\r\n}\r\n\r\nspan.live-icon-container {\r\n  animation: float 3s ease-in-out infinite;\r\n}\r\n\r\n.scroll-feed {\r\n  height: auto !important;\r\n}\r\n\r\n.icon-img {\r\n  height: 32px !important;\r\n}\r\n\r\n.d-flex {\r\n  display: flex !important;\r\n}\r\n\r\n.h-v-center {\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
